import React from "react";
import {
  Grid,
  Segment,
  Divider,
  Header,
  Icon,
  Button,
  Form,
  TextArea,
  Item,
  Input,
  Modal,
} from "semantic-ui-react";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import { Image, List } from "semantic-ui-react";
import axios from "axios";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Table from "react-bootstrap/Table";

import Menutest from "./menu.js";
import { Link } from "react-router-dom";
import { Pagination } from "semantic-ui-react";
import { SemanticToastContainer } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import BackgroundArabic from "../pictures/HedarArabic.png";
import BackgroundEnglish from "../pictures/HedarEnglish.png";
import { API_BASE_URL } from "../utils/endpoints";
//import Modal from "react-modal";

const modDelete = {
  marginTop: 200,
  marginLeft: 520,
  height: "auto",
  textAlign: "left",
};

const modDeletea = {
  marginTop: 200,
  marginLeft: 300,
  height: "auto",
  textAlign: "left",
};

const modAdd = {
  marginTop: 200,
  marginLeft: "30%",
  height: "auto",

  textAlign: "left",
};

const modAdda = {
  marginTop: 200,
  marginLeft: "15%",

  height: "auto",
  textAlign: "right",
};

const mod = {
  marginTop: 200,
  marginLeft: "30%",
  height: 340,
  textAlign: "left",
};

const moda = {
  marginTop: 200,
  marginLeft: "15%",
  height: 340,
  textAlign: "right",
};

class Request extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      persons: [],
      personsearch: [],
      modalIsOpen: false,
      from: "",
      sender_id: "",
      id_record: "",
      totalpage: "1",
      activePage: 1,
      isArabic: false,
      IsOpenDeleteTemplate: false,
      templateIdForeDelete: "",
      templateNameForeDelete: "",
      modalOpenAdd: false,
      modalOpenEdit: false,
      modalOpenDelete: false,

      template_name: "",
      template_value: "",
      searchWord: "",
      totalpagesearch: "1",
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.OpenModalDeleteTemplate = this.OpenModalDeleteTemplate.bind(this);
    this.closeModalDeleteTemplate = this.closeModalDeleteTemplate.bind(this);
  }

  handleOpenAdd = () => this.setState({ modalOpenAdd: true });
  handleCloseAdd = () => this.setState({ modalOpenAdd: false });

  handleOpenEdit = () => this.setState({ modalOpenEdit: true });
  handleCloseEdit = () => this.setState({ modalOpenEdit: false });

  handleOpenDelete = () => this.setState({ modalOpenDelete: true });
  handleCloseDelete = () => this.setState({ modalOpenDelete: false });

  handleChange = (event) => {
    this.setState({ template_name: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    var data = {
      template_name: this.state.template_name,
      template_value: this.state.template_value,
    };
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + "/core/corpsms/template";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/corpsms/template";
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status === "success") {
            window.location = "template";
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  handleEdit = (event) => {
    event.preventDefault();
    var data = {
      template_name: this.state.template_name,
      template_value: this.state.template_value,
      _id: reactLocalStorage.get("id_user_edit_template"),
    };
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + "/core/corpsms/template";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/corpsms/template";
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status === "success") {
            window.location = "template";
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  edit() {
    this.setState({ modalOpenEdit: true });
    var id = reactLocalStorage.get("id_user_edit_template");
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = 0;
    var search = "";
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/gettemplate?page=" +
        page_num +
        "&filter=" +
        search;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/corpsms/gettemplate?page=" +
        page_num +
        "&filter=" +
        search;
    }

    var i;

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result != undefined) {
        for (i = 0; i < res.data.result.templates.length; i++) {
          if (res.data.result.templates[i].id === id) {
            this.setState({
              template_name: res.data.result.templates[i].template_name,
            });
            this.setState({
              template_value: res.data.result.templates[i].template_value,
            });
          }
        }
      }
    });
  }

  onTextChange = (event) => {
    this.setState({ template_value: event.target.value });
  };

  closeModalDeleteTemplate() {
    this.setState({ modalOpenDelete: false });
  }
  OpenModalDeleteTemplate(e) {
    this.setState({
      templateIdForeDelete: e.target.id,
      templateNameForeDelete: e.target.name,
    });
  }
  openModal() {
    this.setState({ modalIsOpen: true });
  }
  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });

    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = activePage - 1;
    var search = "";
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/gettemplate?page=" +
        page_num +
        "&filter=" +
        search;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/corpsms/gettemplate?page=" +
        page_num +
        "&filter=" +
        search;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result !== undefined) {
        this.setState({ persons: res.data.result.templates });
        this.setState({ persons: res.data.result.templates });
        var total = Math.ceil(res.data.result.count / 20);

        this.setState({ totalpage: total });
      }
    });
  };
  handlePaginationChangeSearch = (e, { activePage }) => {
    this.setState({ activePage });

    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = activePage - 1;
    var search = this.state.searchWord;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/gettemplate?page=" +
        page_num +
        "&filter=" +
        search;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/corpsms/gettemplate?page=" +
        page_num +
        "&filter=" +
        search;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result !== undefined) {
        this.setState({ persons: res.data.result.templates });
        this.setState({ persons: res.data.result.templates });
        var total = Math.ceil(res.data.result.count / 20);

        this.setState({ totalpagesearch: total });
      }
    });
  };
  afterOpenModal() {}

  closeModal() {
    this.setState({ modalIsOpen: false });
  }
  componentDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });

      document.querySelector(".fixed_profile").style =
        "margin-right: 0% !important;";
    }
    this.changeData();
  }

  changeData = () => {
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = this.state.activePage - 1;
    var search = "";
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/gettemplate?page=" +
        page_num +
        "&filter=" +
        search;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/corpsms/gettemplate?page=" +
        page_num +
        "&filter=" +
        search;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result != undefined) {
        this.setState({ persons: res.data.result.templates });
        var total = Math.ceil(res.data.result.count / 20);

        this.setState({ totalpage: total });
      }
    });
  };

  Editform = (event) => {
    reactLocalStorage.set("id_user_edit_template", event.target.id);
    window.location = "EditTemplate";
  };

  Deleteform = (event) => {
    event.preventDefault();
    var token = reactLocalStorage.get("accessToken");

    this.setState({ id: this.state.templateIdForeDelete });
    var id_user = this.state.templateIdForeDelete;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
   
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/deletetemplate/"+id_user;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/deletetemplate/"+id_user;
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, {},{ headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status === "success") {
            window.location = "Template";
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };
  searchchange = (event) => {
    this.setState({ searchWord: event.target.value });
    if (event.target.value.length >= 2) {
      var token = reactLocalStorage.get("accessToken");

      // document.querySelector(".view_basic").style = "display:none";
      // document.querySelector(".view_search").style = "display:block";
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      var page_num = this.state.activePage - 1;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/corpsms/gettemplate?page=" +
          page_num +
          "&filter=" +
          event.target.value;
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/corpsms/gettemplate?page=" +
          page_num +
          "&filter=" +
          event.target.value;
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        this.setState({ persons: res.data.result.templates });
        var total = Math.ceil(res.data.result.count) / 20;
        this.setState({ totalpagesearch: total });
      });
    } else if (event.target.value === "") {
      // document.querySelector(".view_basic").style = "display:block";
      //document.querySelector(".view_search").style = "display:none";
      this.changeData();
    }
  };

  render() {
    const { activePage } = this.state;
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_sms">
            <div className="sms_main">
              <Grid columns={2} divided className="fixed_profile">
                <Grid.Row stretched className="fixed_header">
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style yellow_color">
                        {this.state.isArabic ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br />
                <Divider horizontal>
                  {" "}
                  <Header as="h2" color="black">
                    <Icon name="mail outline" color="black" />{" "}
                    {this.state.isArabic ? "   النماذج " : " SMS Templates "}{" "}
                  </Header>{" "}
                </Divider>
                <div className="buttonsHeader">
                  <Input
                    size="small"
                    icon="search"
                    placeholder={
                      this.state.isArabic
                        ? " البحث عن العنوان"
                        : "Search By Title"
                    }
                    onChange={this.searchchange.bind(this)}
                    style={{ float: "right" }}
                  />

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.handleOpenAdd}
                  >
                    <Icon color="black" name="pencil alternate" color="black" />
                    {this.state.isArabic ? " نموذج جديد" : " New Template"}
                  </Button>
                </div>
                <br /> <br /> <br />
                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
                  <thead className="head">
                    <tr>
                      <td>
                        {" "}
                        {this.state.isArabic
                          ? "اسم النموذج"
                          : "Template Name"}{" "}
                      </td>
                      <td>
                        {" "}
                        {this.state.isArabic
                          ? "محتوى النموذج"
                          : "Template Content"}{" "}
                      </td>
                      <td>{this.state.isArabic ? "إعدادات" : "Settings"}</td>
                    </tr>
                  </thead>
                  {this.state.persons.map((person) => (
                    <tbody>
                      <tr>
                        <td> {person.template_name}</td>

                        <td> {person.template_value}</td>

                        <td style={{ textAlign: "center" }}>
                          <Header as="h5">
                            <Icon
                              
                              name="edit outline"
                              color="black"
                              floated={this.state.isArabic ? "left" : "right"}
                              id={person.id}
                              onClick={(event) => {
                                reactLocalStorage.set(
                                  "id_user_edit_template",
                                  event.target.id
                                );
                                this.edit();
                              }}
                            />

                            <Modal
                             closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
                             onClose={this.handleCloseDelete}
                              size="tiny"
                              className="filter"
                              trigger={
                                <Icon
                                  
                                  name="trash alternate outline"
                                  color="black"
                                  floated={
                                    this.state.isArabic ? "left" : "right"
                                  }
                                  id={person.id}
                                  onClick={(e) => {
                                    this.OpenModalDeleteTemplate(e);
                                  }}
                                />
                              }
                              style={
                                this.state.isArabic ? modDeletea : modDelete
                              }
                              floated={this.state.isArabic ? "right" : "left"}
                            >
                              <Header
                                icon="trash alternate outline"
                                content={
                                  this.state.isArabic
                                    ? "حذف النموذج"
                                    : "Delete Templet"
                                }
                              />
                              <Modal.Content>
                                <Header as="h3" textAlign="center">
                                  {" "}
                                  {this.state.isArabic
                                    ? "هل انت متأكد من حذف هذا النموذج ؟"
                                    : "Are you sure you want to delete this sms template ? "}
                                </Header>
                              </Modal.Content>
                              <Modal.Actions>
                                <Button
                                  basic
                                  color="teal"
                                  content={this.state.isArabic ? "نعم" : "Yes"}
                                  onClick={this.Deleteform}
                                />
                                <Button
                                  basic
                                  color="black"
                                  content={this.state.isArabic ? "لا" : "No"}
                                  onClick={() => {
                                    window.location = "Template";
                                  }}
                                />
                              </Modal.Actions>
                            </Modal>
                          </Header>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </Table>
                <br />
                <br />
                <Segment basic />
                <Divider horizontal>
                  <Header
                    as="h5"
                    floated={this.state.isArabic ? "left" : "right"}
                  >
                    <Pagination
                      defaultActivePage={1}
                      onPageChange={this.handlePaginationChange}
                      totalPages={this.state.totalpage}
                      className="page"
                    />
                  </Header>
                  <Header
                    as="h5"
                    floated={this.state.isArabic ? "left" : "right"}
                  />
                </Divider>
              </Segment>
            </div>
          </div>
        </div>

        <Modal
          className="filter"
          size="small"
          open={this.state.modalOpenEdit}
          onClose={this.handleCloseEdit}
          style={this.state.isArabic ? modAdda : modAdd}
          floated={this.state.isArabic ? "right" : "left"}
          closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
        >
          <Header
            icon="edit circle"
            content={this.state.isArabic ? "تعديل النموذج" : "Edit Template"}
          />
          <Modal.Content>
            <Form>
              <Form.Group
                widths="equal"
                style={{
                  textAlign:
                    reactLocalStorage.get("lang") === "ar" ? "right" : "left",
                }}
              >
                <Form.Input
                  floated={this.state.isArabic ? "right" : "left"}
                  fluid
                  label={i18n.t("Name.label")}
                  placeholder={
                    this.state.isArabic ? "اسم النموذج" : "Template Name"
                  }
                  width={6}
                  onChange={this.handleChange}
                  value={this.state.template_name}
                />
              </Form.Group>
              <Form.Field>
                <label>{i18n.t("text.label")}</label>
                <TextArea
                  placeholder="Enter your text"
                  onChange={this.onTextChange}
                  value={this.state.template_value}
                />
              </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("Submit.label")}
              onClick={this.handleEdit}
            />
            <Button
              basic
              color="black"
              content={i18n.t("Cancel.label")}
              onClick={this.handleCloseEdit}
            />
          </Modal.Actions>
        </Modal>

        <Modal
          size="small"
          className="add"
          closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
          open={this.state.modalOpenAdd}
          onClose={this.handleCloseAdd}
          style={this.state.isArabic ? modAdda : modAdd}
          floated={this.state.isArabic ? "right" : "left"}
        >
          <Header
            content={this.state.isArabic ? "نموذج جديد" : "New Template"}
          />
          <Modal.Content>
            <Form>
              <Form.Group
                widths="equal"
                style={{
                  textAlign:
                    reactLocalStorage.get("lang") === "ar" ? "right" : "left",
                }}
              >
                <Form.Input
                  floated={this.state.isArabic ? "right" : "left"}
                  fluid
                  label={i18n.t("Name.label")}
                  placeholder={
                    this.state.isArabic ? "اسم النموذج" : "Template Name"
                  }
                  width={6}
                  onChange={this.handleChange}
                  required
                />
              </Form.Group>
              <Form.Field>
                <label>{i18n.t("text.label")}</label>
                <TextArea
                  placeholder={
                    this.state.isArabic ? "أدخل النص" : "Enter your Text"
                  }
                  onChange={this.onTextChange}
                  value={this.state.template_value}
                />
              </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("Submit.label")}
              onClick={this.handleSubmit}
            />
            <Button
              basic
              color="black"
              content={i18n.t("Cancel.label")}
              onClick={this.handleCloseAdd}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(Request);
